import * as service from 'services/share.service';
import { createSafeAsyncThunk } from 'store/store.helper';
const SLICE_ID = 'app__share';

export const shareProject = createSafeAsyncThunk(SLICE_ID + '/shareProject', async (params: service.ShareProject) => {
  const response = await service.shareProject(params);
  return response.data;
});

export const getCollaborators = createSafeAsyncThunk(SLICE_ID + '/getCollaborators', async (projectId: ProjectId) => {
  const response = await service.getCollaborators(projectId);
  return response.data;
});

export const shareProjectToSupport = createSafeAsyncThunk(
  SLICE_ID + '/shareProjectToSupport',
  async (params: number) => {
    const response = await service.shareProjectToSupport(params);
    return response.data;
  }
);

export const removeCollaborator = createSafeAsyncThunk(
  SLICE_ID + '/removeCollaborator',
  async (params: service.RemoveCollaborator) => {
    const response = await service.removeCollaborator(params);
    return response.data;
  }
);
